import { Row, Col, Divider, Typography } from 'antd';
import { memo, useRef } from 'react';
import useElementSize from '../hooks/useElementSize';
import useIntersectionObserver from '../hooks/useIntersectionObserver';

const { Title } = Typography;

interface Field {
    name: string;
    content: React.ReactNode;
}

interface RenderFieldProps {
    groupTitle: string;
    hideGroupTitle: boolean;
    normalFields: Field[];
    arrayFields: Field[];
    mapFields: Field[];
    renderNormalFields: (fields: Field[]) => React.ReactNode;
    normalizeTitle: (title: string) => string;
}

const RenderField = ({
    groupTitle,
    hideGroupTitle,
    normalFields,
    arrayFields,
    mapFields,
    renderNormalFields,
    normalizeTitle
}: RenderFieldProps) => {

    const sectionRef = useRef<HTMLDivElement | null>(null);
    const size = useElementSize(sectionRef);
    const isVisible = useIntersectionObserver(sectionRef, {
        root: null,
        threshold: 0.1,
        rootMargin: '200px',
    });

    return (
        <div ref={sectionRef}/*  style={!isVisible ? {
            height: size.height,
            width: size.width,
        } : {}} */>

            {!hideGroupTitle && groupTitle !== 'other' /* && isVisible */ && ( // Only show title if visible
                <>
                    <Title level={4} style={{ marginTop: "25px", lineHeight: "3px" }}>
                        {normalizeTitle(groupTitle)}
                    </Title>
                    <Divider style={{ marginTop: '3px', marginBottom: '10px' }} />
                </>
            )}

            {normalFields.length > 0 /* && isVisible */ && ( // Only show normal fields if visible
                <Row gutter={[10, 10]} className='my-2' >
                    {renderNormalFields(normalFields)}
                </Row>
            )}

            {arrayFields.length > 0 /* && isVisible */ && ( // Only show array fields if visible
                <Row gutter={[10, 10]} className='my-2'>
                    {arrayFields.map((field) => (
                        <Col span={24} key={field.name}>
                            {field.content}
                        </Col>
                    ))}
                </Row>
            )}

            {mapFields.length > 0 /* && isVisible  */ && ( // Only show map fields if visible
                <Row gutter={[10, 10]} >
                    {mapFields.map((field) => (
                        <Col span={24} key={field.name}>
                            <div>{field.content}</div>
                        </Col>
                    ))}
                </Row>
            )}
        </div>
    );
};

export default memo(RenderField);


// import { Row, Col, Divider, Typography } from 'antd';
// import { memo, useRef } from 'react';
// import useElementSize from '../hooks/useElementSize';
// import useIntersectionObserver from '../hooks/useIntersectionObserver';

// const { Title } = Typography;

// interface Field {
//     name: string;
//     content: React.ReactNode;
// }

// interface RenderFieldProps {
//     groupTitle: string;
//     hideGroupTitle: boolean;
//     normalFields: Field[];
//     arrayFields: Field[];
//     mapFields: Field[];
//     renderNormalFields: (fields: Field[]) => React.ReactNode;
//     normalizeTitle: (title: string) => string;
// }

// const RenderField = ({
//     groupTitle,
//     hideGroupTitle,
//     normalFields,
//     arrayFields,
//     mapFields,
//     renderNormalFields,
//     normalizeTitle
// }: RenderFieldProps) => {

//     const sectionRef = useRef<HTMLDivElement | null>(null);
//     const size = useElementSize(sectionRef);
//     const isVisible = useIntersectionObserver(sectionRef, { threshold: 0.1 });

//     // Use isVisible to conditionally render or apply styles
//     return (
//         <div ref={sectionRef} style={!isVisible ? {
//             height: size.height,
//             width: size.width,
//             opacity: 0.5, // Example: apply opacity when not visible
//         } : {}}>

//             {!hideGroupTitle && groupTitle !== 'other' && isVisible && ( // Only show title if visible
//                 <>
//                     <Title level={4} style={{ marginTop: "25px", lineHeight: "5px" }}>
//                         {normalizeTitle(groupTitle)}
//                     </Title>
//                     <Divider style={{ marginTop: '3px', marginBottom: '15px' }} />
//                 </>
//             )}

//             {normalFields.length > 0 && isVisible && ( // Only show normal fields if visible
//                 <Row gutter={[10, 10]} style={{ marginBottom: '.5rem' }}>
//                     {renderNormalFields(normalFields)}
//                 </Row>
//             )}

//             {arrayFields.length > 0 && isVisible && ( // Only show array fields if visible
//                 <Row gutter={[10, 10]}>
//                     {arrayFields.map((field) => (
//                         <Col span={24} style={{ marginBottom: '.5rem' }} key={field.name}>
//                             {field.content}
//                         </Col>
//                     ))}
//                 </Row>
//             )}

//             {mapFields.length > 0 && isVisible && ( // Only show map fields if visible
//                 <Row gutter={[10, 10]}>
//                     {mapFields.map((field) => (
//                         <Col span={24} key={field.name}>
//                             <div>{field.content}</div>
//                         </Col>
//                     ))}
//                 </Row>
//             )}
//         </div>
//     );
// };

// export default memo(RenderField);
